import { I18n } from "@assets/strings";
import React from "react";
import { Link } from "react-router";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { useIsLearner } from "@domain/currentProfile/hooks";
import { Group, GroupType } from "@domain/group/group";
import { ClosableModal } from "@ui/modals/closableModal";
import { alpha } from "@ui/styles/utils";
import { Primary } from "@ui/components/containers/primary";
import { DeleteIconBig } from "@ui/components/icons";
import { ProfilePicture } from "@ui/components/profile/profileOrganizationPicture";
import { BigRow, BigRowWrapper } from "@ui/components/rows";

interface GroupsModalProps extends React.HTMLAttributes<HTMLDivElement> {
	groups: Group[];
	type: GroupType;
	loading: boolean;
	close: () => void;
}

export const GroupsModal: React.FC<GroupsModalProps> = ({ groups, type, loading, close, ...htmlProps }) => {
	const isLearner = useIsLearner();

	return (
		<Container
			close={close}
			title={type === "SHAREROOM" ? I18n.t("shareroom.list.title") : I18n.t("discussion.list.title")}
			{...htmlProps}
		>
			{isLearner ? null : (
				<BigRowWrapper>
					<Link to={Path.GroupEditor("new", type)}>
						<Row>
							<NewButton>
								<DeleteIconBig />
							</NewButton>
							<Primary>
								<b>{type === "SHAREROOM" ? I18n.t("shareroom.new.title") : I18n.t("discussion.new.title")}</b>
							</Primary>
						</Row>
					</Link>
				</BigRowWrapper>
			)}
			{groups.map((group) =>
				group ? (
					<BigRowWrapper key={group.id}>
						<Link onClick={close} to={type === "SHAREROOM" ? Path.Shareroom(group) : Path.Discussion(group)}>
							<Row>
								<ProfilePicture picture={group.banner} />
								<Primary>
									<b>{group.name}</b>
								</Primary>
							</Row>
						</Link>
					</BigRowWrapper>
				) : (
					<></>
				)
			)}
			{loading && <ClipLoader />}
		</Container>
	);
};

const Container = styled(ClosableModal)`
	align-items: stretch;

	min-height: 600px;
	@media (max-width: 900px) {
		min-height: 400px;
	}
`;

const NewButton = styled.div`
	background-color: ${({ theme }) => theme.colors.primary};
	box-shadow: 0 2px 14px 0 ${({ theme }) => alpha(theme.colors.primary, 0.6)};
	padding: 15px;
	svg  {
		width: 20px;
		height: 20px;
		transform: rotate(45deg);
		path {
			fill: ${({ theme }) => theme.colors.white};
		}
	}
`;

const Row = styled(BigRow)`
	cursor: pointer;
`;
